import { useEffect, useMemo, useState } from 'react';
import { Card, Dropdown, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { Storage } from 'react-jhipster';

import { updateLocale } from 'pages/thermography/shared/reducers/locale';
import { useAppDispatch, useAppSelector } from 'pages/thermography/config/store';

type LocaleKey = 'pt-br' | 'en';

const LOCALES: Record<LocaleKey, { label: string; flag: React.ReactNode }> = {
    'pt-br': {
        label: 'Português (Brasil)',
        flag: (
            <span role="img" aria-label="Brasil" style={{ fontSize: 18, lineHeight: 1 }}>
                🇧🇷
            </span>
        )
    },
    en: {
        label: 'English',
        flag: (
            <span role="img" aria-label="England" style={{ fontSize: 18, lineHeight: 1 }}>
                🇬🇧
            </span>
        )
    }
};

function getInitialLocale(): LocaleKey {
    const stored = Storage.session.get('locale', 'pt-br') as string;
    return stored === 'en' ? 'en' : 'pt-br';
}

const LanguageDropdown = () => {
    const dispatch = useAppDispatch();
    const reduxLocale = useAppSelector(state => state.locale.currentLocale) as LocaleKey | '';
    const [locale, setLocale] = useState<LocaleKey>(() => getInitialLocale());

    const current = useMemo(() => LOCALES[locale], [locale]);

    useEffect(() => {
        if (reduxLocale === 'en' || reduxLocale === 'pt-br') {
            setLocale(reduxLocale);
        }
    }, [reduxLocale]);

    const onSelectLocale = (next: LocaleKey) => {
        if (next === locale) return;

        // 1) salva na sessão (registerLocale vai pegar daqui no boot)
        Storage.session.set('locale', next);

        // 2) atualiza redux; I18nLocaleSync propaga para i18next
        dispatch(updateLocale(next));

        // 3) atualiza UI do toggle (bandeira)
        setLocale(next);
    };

    return (
        <Nav.Item>
            <Dropdown autoClose="outside" className="h-100">
                <Dropdown.Toggle
                    as={Link}
                    to="#!"
                    className="dropdown-caret-none nav-link h-100 d-flex align-items-center px-2"
                    variant=""
                    aria-label="Selecionar idioma"
                >
                    {current.flag}
                </Dropdown.Toggle>

                <Dropdown.Menu
                    align="end"
                    className="navbar-dropdown-caret py-0 dropdown-nine-dots shadow border"
                >
                    <Card className="position-relative border-0">
                        <Card.Body className="p-2">
                            {(Object.keys(LOCALES) as LocaleKey[]).map(key => {
                                const item = LOCALES[key];
                                const active = key === locale;

                                return (
                                    <Dropdown.Item
                                        key={key}
                                        active={active}
                                        onClick={() => onSelectLocale(key)}
                                        className="d-flex align-items-center gap-2 rounded-2"
                                    >
                                        <span style={{ width: 22, display: 'inline-flex', justifyContent: 'center' }}>
                                            {item.flag}
                                        </span>
                                        <span className="flex-grow-1">{item.label}</span>
                                        {active && <FeatherIcon icon="check" size={16} />}
                                    </Dropdown.Item>
                                );
                            })}
                        </Card.Body>
                    </Card>
                </Dropdown.Menu>
            </Dropdown>
        </Nav.Item>
    );
};

export default LanguageDropdown;
